import React, { FC } from 'react';

import { Styled } from './index.styles';
import { ParkingProps } from '../../organisms/HotelInformation/HotelInformation.types';
import { useCheckBreakpoint } from '../../hooks';
import clsx from 'clsx';
import { useConditionalHQVContext } from '../../hooks/lib/useConditionalHQVContext';
import { reorderCurrencyForRTL, getLocaleFromDocument } from '../../utils/index';
import { AR_LOCALE } from '../../modules/constants';
import { useConditionalPageContextSERP, useConditionalServerDataHotelInformationSERP } from '../../hooks';

export const HotelParking: FC<{ hotelInformationData: { property: { parking: [] } } }> = ({ hotelInformationData }) => {
  const { jsonContent } = useConditionalServerDataHotelInformationSERP();
  const { pageVal } = useConditionalPageContextSERP();
  const parkingInfoList = hotelInformationData?.property?.parking;
  const isViewportL = useCheckBreakpoint('viewportL');
  // Read HQV state via the flag-aware hook. When rendered inside the HQV modal, the parent
  // wraps children with HQVModalFlagContext ('serp' or 'adf') so this call picks up the correct
  // store (Zustand when the page's *_ZUSTAND flag is on, React Context otherwise). Reading
  // Zustand directly here caused a split-brain when the flag was off (writers went to Context,
  // this reader always went to Zustand).
  const { hqvState } = useConditionalHQVContext();
  return (
    <Styled>
      <div
        className={clsx(
          'parking',
          pageVal === 'chat' && 'parking-chat',
          `${hqvState.modalOpenState ? 'hqv-modal' : ''}`
        )}
      >
        <div className={clsx(pageVal === 'chat' ? 'mt-2' : '', 'col', 'm-icon-text', 'section-heading')}>
          {pageVal !== 'chat' && (
            <span
              className={clsx(
                pageVal === 'chat'
                  ? 'icon-m'
                  : isViewportL
                  ? 'icon-m icon-decorative left-col-icon'
                  : 'icon-s icon-decorative left-col-icon',
                'icon-parking',
                'check-out',
                'parking-policy-icon'
              )}
            ></span>
          )}
          <span
            className={clsx(
              pageVal === 'chat'
                ? 't-subtitle-s parking-heading-chat mt-2 mb-2'
                : isViewportL
                ? 't-subtitle-l'
                : 't-subtitle-m',
              'parking-heading'
            )}
          >
            {jsonContent?.parkingLabel}
          </span>
        </div>
        <div
          className={clsx(
            pageVal === 'chat' ? (isViewportL ? 'mt-0 mb-3 pl-0' : 'mt-0 mb-3 pl-0') : '',
            'parking-information'
          )}
        >
          {parkingInfoList &&
            parkingInfoList.map((parkingInfo: ParkingProps, idx: number) => (
              <div key={'park' + idx}>
                <div
                  className={clsx(
                    pageVal === 'chat' ? 't-font-s m-0' : isViewportL ? 't-font-s' : 't-font-xs',
                    'parking-item'
                  )}
                  key={idx}
                >
                  {getLocaleFromDocument() === AR_LOCALE
                    ? reorderCurrencyForRTL(parkingInfo?.fees?.description ?? '')
                    : parkingInfo?.fees?.description}
                </div>
                <div
                  className={clsx(
                    pageVal === 'chat' ? 't-font-s' : isViewportL ? 't-font-s' : 't-font-xs',
                    'parking-item'
                  )}
                >
                  {getLocaleFromDocument() === AR_LOCALE
                    ? reorderCurrencyForRTL(parkingInfo?.description ?? '')
                    : parkingInfo?.description}
                </div>
              </div>
            ))}
        </div>
      </div>
      {/* )} */}
    </Styled>
  );
};
